/**
 * Whether a researched listing shows the BOM line's manufacturer part number.
 * buyer-service decides it (services/research/partNumberMatch.js) and stores it
 * on the candidate as `partNumberCheck`; this only reads it. Absent when the
 * line has no part number, or on research from before the check existed.
 */

export type PartNumberStatus = 'match' | 'mismatch' | 'unverified';

export interface PartNumberCheckView {
  status: PartNumberStatus;
  /** The part number the supplier's listing shows, when it shows one. */
  listedPartNumber?: string;
}

const STATUS: Record<string, PartNumberStatus> = {
  MATCH: 'match',
  MISMATCH: 'mismatch',
  UNVERIFIED: 'unverified',
};

export const partNumberCheckOf = (raw: unknown): PartNumberCheckView | undefined => {
  if (!raw || typeof raw !== 'object') return undefined;
  const { status, listedPartNumber } = raw as { status?: unknown; listedPartNumber?: unknown };
  const view = typeof status === 'string' ? STATUS[status] : undefined;
  if (!view) return undefined;
  const listed = typeof listedPartNumber === 'string' && listedPartNumber.trim() ? listedPartNumber.trim() : undefined;
  return { status: view, ...(listed ? { listedPartNumber: listed } : {}) };
};
